module.exports = __webpack_public_path__ + "img/info_bg.0f849375.png";